import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';
import styles from './SearchView.styles';
import { InterventionOrderCriteria } from 'src/interfaces/api/InterventionOrder';
import StatusSelect from './components/StatusSelect';
import { empty } from 'src/utils/ObjectUtils';

const useStyles = createUseStyles(styles);

interface Props {
  searchCriteria: InterventionOrderCriteria;
  onCriteriaChange: (criteria: InterventionOrderCriteria) => void;
}

const SearchView: FC<Props> = ({ searchCriteria, onCriteriaChange }) => {
  const classes = useStyles();

  const handleChangeCriteria = (fieldName: keyof InterventionOrderCriteria, value: any) => {
    const newValue = empty(value) ? undefined : value;
    onCriteriaChange({ ...searchCriteria, [fieldName]: newValue });
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>Filtrer les bon d'interventions</div>

      <div className={classes.filterContainer}>
        <StatusSelect value={searchCriteria.status || []} onChange={(value) => handleChangeCriteria('status', value)} />
      </div>
    </div>
  );
};

export default SearchView;
